export var BlogRoutes;
(function (BlogRoutes) {
    BlogRoutes["BLOG"] = "blog";
})(BlogRoutes || (BlogRoutes = {}));
